(() => {
  if (window.__HIGHLIGHT_FEATURES__) return;
  window.__HIGHLIGHT_FEATURES__ = true;

  const clean = (text) =>
    (text || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .replace(/[\s:|•\-–—=]+$/g, "")
      .trim();

  // Compatible normalize (no unicode property regex)
  const normalize = (text) =>
    clean(text)
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  function findH3(doc, title) {
    const wanted = normalize(title);
    const h3s = Array.from(doc.querySelectorAll("h3"));
    return (
      h3s.find((h) => normalize(h.textContent) === wanted) ||
      h3s.find((h) => normalize(h.textContent).includes(wanted)) ||
      null
    );
  }

  function extract(html, limit) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const h3 = findH3(doc, "KEY FEATURES");
    if (!h3) return null;

    const items = [];
    let node = h3.nextSibling;

    while (node) {
      if (node.nodeType === 1 && node.tagName && node.tagName.toLowerCase() === "h3") break;

      if (node.nodeType === 1) {
        const strongs = Array.from(node.querySelectorAll("strong"));
        for (const st of strongs) {
          if (items.length >= limit) break;
          const t = clean(st.textContent);
          if (t) items.push(t);
        }
      }

      if (items.length >= limit) break;
      node = node.nextSibling;
    }

    return items;
  }

  function hideWrapper(el) {
    const wrapper = el.closest(".product-info__block");
    if (wrapper) {
      wrapper.style.display = "none"; // yer kaplamaz
      return;
    }
    el.style.display = "none";
  }

  function showWrapper(el) {
    const wrapper = el.closest(".product-info__block");
    if (wrapper) wrapper.removeAttribute("hidden");
    el.removeAttribute("hidden");
  }

  function hydrate(el) {
    if (el.__hydrated) return;
    el.__hydrated = true;

    const tpl = el.querySelector("template");
    const list = el.querySelector("ul");
    if (!tpl || !list) return;

    let limit = parseInt(el.getAttribute("data-limit") || "3", 10);
    if (!Number.isFinite(limit) || limit < 1) limit = 3;

    const html = tpl.innerHTML || "";
    const items = extract(html, limit);

    if (!items || !items.length) {
      hideWrapper(el);
      return;
    }

    // Content var → göster (FOUC önlemek için wrapper hidden geliyor)
    showWrapper(el);

    list.innerHTML = "";
    items.forEach((text) => {
      const li = document.createElement("li");
      li.className = "highlight-features__item";
      li.innerHTML = `
        <span class="highlight-features__icon"></span>
        <span class="highlight-features__text"></span>
      `;
      li.querySelector(".highlight-features__text").textContent = text;
      list.appendChild(li);
    });
  }

  function init() {
    document.querySelectorAll("[data-highlight-features]").forEach(hydrate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();